export default "__VITE_ASSET__CBGlp3Or__"